import { useQuery, useQueryClient } from "@tanstack/react-query";
import API from "@src/API";
import UserData from "../components/Controls/UserData";
import { queryKeys } from "./keys";

function asArray(value) {
  return Array.isArray(value) ? value : [];
}

export async function fetchSessionShell() {
  const resp = await API.getAsync("/Person/SessionShell");
  if (!resp?.ok) {
    throw new Error(resp?.jsonData?.message || resp?.jsonData?.error || "Could not load session");
  }
  const data = resp.jsonData || {};
  const shell = {
    person: data.person || null,
    agreements: asArray(data.agreements),
    employers: asArray(data.employers),
    openNoticeCount: Number(data.openNoticeCount ?? data.OpenNoticeCount ?? 0) || 0,
    unreadChatCount: Number(data.unreadChatCount ?? data.UnreadChatCount ?? 0) || 0,
  };
  UserData.patchSessionShell(shell);
  return shell;
}

export function useSessionShellQuery(options = {}) {
  return useQuery({
    queryKey: queryKeys.sessionShell(),
    queryFn: fetchSessionShell,
    staleTime: 0,
    refetchOnMount: "always",
    ...options,
  });
}

export async function refreshSessionShell(queryClient) {
  await queryClient.invalidateQueries({ queryKey: queryKeys.sessionShell() });
  await queryClient.refetchQueries({ queryKey: queryKeys.sessionShell() });
}

export function useRefreshSessionShell() {
  const queryClient = useQueryClient();
  return () => refreshSessionShell(queryClient);
}
